
/**
 * 자료 유형
 */
export type GetCourseAssets200ContentItemAssetType = typeof GetCourseAssets200ContentItemAssetType[keyof typeof GetCourseAssets200ContentItemAssetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseAssets200ContentItemAssetType = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  DOCUMENT: 'DOCUMENT',
  IMAGE: 'IMAGE',
  MARKDOWN: 'MARKDOWN',
  PDF: 'PDF',
  ZIP: 'ZIP',
  PRESENTATION: 'PRESENTATION',
  SPREADSHEET: 'SPREADSHEET',
  OTHER_ASSET: 'OTHER_ASSET',
} as const;
